import DashboardLayout from "../../Components/Common/DashboardLayout";
import NCProTableComponents from "../../Components/Pages/NCPro/NCProTableComponents";
import LandingPage from "../../Components/Pages/Welcome/LandingPage";
import UserManagement from "../../Components/Pages/Users/UserManagement";
import InitiateComponent from "../../Components/Pages/NCPro/InitiateComponent";
import ViewDetailsComponent from "../../Components/Pages/NCPro/ViewDetailsComponent";
import EditDetailsComponent from "../../Components/Pages/NCPro/EditDetailsComponent";
import ActionDetailsComponent from "../../Components/Pages/NCPro/ActionDetailsComponent";
import ReviewDetailsComponent from "../../Components/Pages/NCPro/ReviewDetailsComponent";
import ClosureDetailsComponent from "../../Components/Pages/NCPro/ClosureDetailsComponent";
import NotFound from "../../pages/404";
import SiteSettings from "../../Components/Pages/Settings/SiteSettings";

import { useParams } from "react-router-dom";
import AnalysisDetailsComponent from "../../Components/Pages/NCPro/RCAnalysisDetailsComponent";

export default function NCProPages() {
  const { page, id } = useParams();

  const componentMap = {
    welcome: {
      label: "Welcome",
      component: <LandingPage />,
    },
    users: {
      label: "User Management",
      component: <UserManagement />,
    },
    settings: {
      label: "Settings",
      component: <SiteSettings />,
    },
    view: {
      label: "View",
      component: id
        ? <ViewDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="view" />,
    },
    initiate: {
      label: "Initiate",
      component: <InitiateComponent />,
    },
    edit: {
      label: "Edit",
      component: id
        ? <EditDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="edit" />,
    },
    action: {
      label: "Action",
      component: id
        ? <ActionDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="action" />,
    },
    review: {
      label: "Review",
      component: id
        ? <ReviewDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="review" />,
    },
    closure: {
      label: "Closure",
      component: id
        ? <ClosureDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="closure" />,
    },
    analysis: {
      label: "Analysis",
      component: id
        ? <AnalysisDetailsComponent content={{ ncrId: id }} />
        : <NCProTableComponents label="action" newPage='analysis' />,
    },
  };

  const content = componentMap[page];
  if (!content) return <NotFound />;

  return <DashboardLayout key={page + id} content={content} />;
}
